import clothingRaw from './clothing-catalog.json';
import cropsRaw from './crops.json';
import furnitureRaw from './furniture-catalog.json';
import questsRaw from './quests.json';
import type {
  ClothingDefinition,
  CropDefinition,
  FurnitureDefinition,
  QuestDefinition,
} from '../../core/domain/types';
import {
  clothingCatalogSchema,
  cropSchema,
  furnitureCatalogSchema,
  questSchema,
} from '../schemas/configSchemas';

export const crops: CropDefinition[] = cropSchema.array().parse(cropsRaw);

const furnitureCatalog = furnitureCatalogSchema.parse(furnitureRaw);
export const furniture: FurnitureDefinition[] = furnitureCatalog.themes.flatMap(
  (theme, themeIndex) =>
    furnitureCatalog.types.map((item, itemIndex) => ({
      id: `furniture_${theme.id}_${item.id}`,
      name: `${theme.name}·${item.name}`,
      theme: theme.id,
      width: item.width,
      height: item.height,
      layer: item.layer,
      price: Math.round(item.basePrice * theme.priceMultiplier),
      color: theme.color,
      unlockLevel: Math.min(15, 1 + themeIndex * 3 + Math.floor(itemIndex / 3)),
    })),
);

const clothingCatalog = clothingCatalogSchema.parse(clothingRaw);
export const clothing: ClothingDefinition[] = clothingCatalog.pieces.flatMap((piece, pieceIndex) =>
  clothingCatalog.colors.map((color, colorIndex) => ({
    id: `clothing_${piece.slot}_${color.id}`,
    name: `${color.name}${piece.name}`,
    slot: piece.slot,
    conflictSlots:
      piece.slot === 'dress'
        ? (['top', 'bottom'] as const)
        : piece.slot === 'top' || piece.slot === 'bottom'
          ? (['dress'] as const)
          : [],
    color: color.value,
    price: piece.basePrice + colorIndex * 4,
    unlockLevel: Math.min(15, 1 + Math.floor((pieceIndex * 10 + colorIndex) / 5)),
  })),
);

export const quests: QuestDefinition[] = questSchema.array().parse(questsRaw);

function assertUniqueIds(items: Array<{ id: string }>, group: string): void {
  const seen = new Set<string>();
  for (const item of items) {
    if (seen.has(item.id)) throw new Error(`${group} 存在重复 ID：${item.id}`);
    seen.add(item.id);
  }
}

assertUniqueIds(crops, '作物');
assertUniqueIds(furniture, '家具');
assertUniqueIds(clothing, '服装');
assertUniqueIds(quests, '任务');

export const cropById = new Map(crops.map((item) => [item.id, item]));
export const furnitureById = new Map(furniture.map((item) => [item.id, item]));
export const clothingById = new Map(clothing.map((item) => [item.id, item]));
export const questById = new Map(quests.map((item) => [item.id, item]));
